import { Fragment } from "react";
import classNames from "classnames";

import Button from "components/UI/Button/Button";

import "./FooterWrapper.scss";

export default function FooterWrapper({
  className,
  title,
  subtitle,
  icon,
  titleButton,
  to,
  onClick,
}) {
  const iconStyle = { backgroundImage: `url(${icon})` };

  return (
    <div className={classNames("footer-wrapper", className)}>
      <div className="footer-wrapper__header">
        <div>
          <p className="footer-wrapper__header-title">{title}</p>
          {subtitle && <p className="footer-wrapper__header-subtitle">{Array.isArray(subtitle) ? subtitle.map((item, i) => <Fragment key={i}>{item}</Fragment>) : subtitle}</p>}
        </div>
        <Button className="footer-wrapper__button" title={titleButton} to={to} onClick={onClick} />
      </div>
      <div className="footer-wrapper__icon" style={iconStyle} />
    </div>
  );
}
